var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item)?_c('div',[(!_vm.item.includes('<br>'))?[_vm._v(" "+_vm._s(_vm.item)+" ")]:_vm._l((_vm.splitData(_vm.item)),function(split){return _c('div',{key:split},[_c('div',[_vm._v(_vm._s(split))])])})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }